import React, { useRef } from 'react';

import './index.module.less';
import PopupMenu from '@widgets/PopupMenu';
import { customDateStr } from './utils';

interface IProps {
  item: {
    phone: string;
    dateStr: string;
    msg: string;
    uid: string;
  };
  onTap: (uid: string) => void;
}

const MessageItem = (props: IProps) => {
  const actionAnchorRef = useRef<HTMLDivElement>(null);

  const { item, onTap } = props;
  const clickItem = () => {
    PopupMenu.show({
      width: 160,
      items: [
        {
          title: '删除该短信',
          value: 1,
        },
      ],
      anchor: actionAnchorRef,
      onTap(_, value) {
        onTap && onTap(item.uid);
      },
    });
  };
  return (
    <div className="flex" styleName="list-item" onClick={clickItem}>
      <div className="flex" styleName="item-header">
        <div className="els" styleName="item-header-title">
          {item.phone || ''}
        </div>
        <div styleName="item-header-date" ref={actionAnchorRef}>
          {item.dateStr ? customDateStr(Number(item.dateStr)) : ''}
        </div>
      </div>
      <p styleName="item-text">{item.msg || ''}</p>
    </div>
  );
};

export default MessageItem;
